import { getRegCart } from '../redux/selectors/shared';
import { isLoggedIn, isNewRegistration } from '../redux/selectors/currentRegistrant';
import { requireRegApproval } from '../redux/selectors/event';
import { setPendingApprovalStatus, updateInviteeStatusAndContactIdInStore } from '../redux/persona';
import { getDefaultWebsitePageId } from '../redux/website';
import { getConfirmationPageIdForInvitee } from '../utils/confirmationUtil';
import { getPagePath } from '../redux/pathInfo';
import { getPrimaryAttendee } from '../redux/registrationForm/regCart/selectors';

const setInviteePersona = async (store) => {
  const state = store.getState();
  const regCart = getRegCart(state) || {};
  if (isLoggedIn(state)) {
    if (isNewRegistration(state) &&
      regCart.status !== 'INPROGRESS') {
      if (requireRegApproval(state)) {
        await store.dispatch(setPendingApprovalStatus(state));
      }
    } else {
      await store.dispatch(updateInviteeStatusAndContactIdInStore(getPrimaryAttendee(regCart)));
    }
  }
};

export const createConfirmationPageHandler = (store) => async (nextRouterState) => {
  let nextPage = getDefaultWebsitePageId(store.getState());
  if (isLoggedIn(store.getState())) {
    await setInviteePersona(store);
    nextPage = await store.dispatch(getConfirmationPageIdForInvitee(store.getState()));
  }
  nextRouterState.history.replace(getPagePath(store.getState(), nextPage));
};
